import * as Yup from 'yup';
import { TFunction } from 'i18next';

import { IRegistrationForm } from './types';
import { PASSWORD_MAXIMUM_LENGTH, PASSWORD_MINIMUM_LENGTH } from 'features/Registration/constants';

export const initialValues: IRegistrationForm = { name: '', email: '', password: '', confirmPassword: '' };

export const createRegistrationSchema = (t: TFunction) => Yup.object().shape({
  name: Yup.string()
    .min(2, t('auth.validation.nameMin'))
    .max(50, t('auth.validation.nameMax'))
    .required(t('auth.validation.nameRequired')),
  email: Yup.string().email(t('auth.validation.emailInvalid')).required(t('auth.validation.emailRequired')),
  password: Yup.string()
    .min(
      PASSWORD_MINIMUM_LENGTH,
      t('auth.validation.passwordMin', { min: PASSWORD_MINIMUM_LENGTH })
    )
    .max(
      PASSWORD_MAXIMUM_LENGTH,
      t('auth.validation.passwordMax', { max: PASSWORD_MAXIMUM_LENGTH })
    )
    .required(t('auth.validation.passwordRequired')),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], t('auth.validation.passwordsMatch'))
    .required(t('auth.validation.passwordsMatch')),
});
